import React, {useState} from 'react';

export function merchantProgress(account, policyId) {
  if (account?.loopAuthorization?.enabled === false) return 'Autorización suspendida por Loop';
  if (!account?.acceptanceId) return account?.loopAuthorization?.enabled ? 'Autorizado por Loop · pendiente de datos y acuerdo' : 'Pendiente de autorización y solicitud';
  if (account.status === 'suspended') return 'Cobros suspendidos · requiere revisión';
  if (account.status === 'rejected') return 'El negocio debe corregir sus datos';
  if (account.policyId !== policyId) return 'Pendiente de aceptar el acuerdo vigente';
  if (account.status === 'approved') return 'Solicitud aprobada · condiciones verificadas al cobrar';
  return 'Datos y acuerdo recibidos · pendiente de revisión';
}

export default function MerchantAuthorizationPanel({businesses=[], accounts=[], policyId, enabled=false, suspensionEnabled=false, busy=false, onAction, onReview}) {
  const [query,setQuery]=useState('');
  const byId=new Map(accounts.map(a=>[a.businessId,a]));
  const rows=new Map(businesses.map(b=>[b.id,{id:b.id,name:b.name||b.businessName||b.id}]));
  accounts.forEach(a=>{if(!rows.has(a.businessId))rows.set(a.businessId,{id:a.businessId,name:a.legalName||a.businessId});});
  const matches=[...rows.values()].filter(b=>`${b.name} ${b.id}`.toLocaleLowerCase().includes(query.trim().toLocaleLowerCase()));
  return <section className="lg-authorization" aria-label="Autorización de cobros por negocio">
    <h4>Cobros de tus negocios</h4>
    <p>Autoriza al negocio desde aquí. Para cobrar, debe completar sus datos, aceptar el acuerdo y superar la revisión.</p>
    {!enabled && <p role="status">La autorización por negocio estará disponible cuando se actualice el servidor.</p>}
    <label>Buscar negocio<input value={query} onChange={e=>setQuery(e.target.value)} placeholder="Nombre del negocio"/></label>
    {!matches.length && <p>No hay negocios que coincidan.</p>}
    {matches.map(b=>{
      const account=byId.get(b.id), authorized=account?.loopAuthorization ? account.loopAuthorization.enabled : account?.status==='approved';
      return <div className="lg-row" key={b.id}><div><strong>{b.name}</strong><small>{merchantProgress(account,policyId)}</small></div><div className="lg-authorization-actions">
        <button type="button" disabled={busy||!enabled||(authorized&&!suspensionEnabled)} onClick={()=>onAction({operation:'authorize',businessId:b.id,enabled:!authorized})}>{authorized?(suspensionEnabled?'Suspender autorización':'Autorizado por Loop'):'Autorizar cobros'}</button>
        {account?.acceptanceId && <button type="button" disabled={busy} onClick={()=>onReview(account)}>Revisar solicitud</button>}
      </div></div>;
    })}
  </section>;
}
